import { render, staticRenderFns } from "./ResidentialMeals.vue?vue&type=template&id=2f437749&scoped=true&"
import script from "./ResidentialMeals.vue?vue&type=script&lang=js&"
export * from "./ResidentialMeals.vue?vue&type=script&lang=js&"
import style0 from "./ResidentialMeals.vue?vue&type=style&index=0&id=2f437749&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f437749",
  null
  
)

export default component.exports